import React from "react";
import { Linkedin, Instagram } from "lucide-react";
import { SITE } from "../lib/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#122644] text-[#FDFBF7] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-x-4 gap-y-10 md:gap-10 lg:gap-16 pb-16 border-b border-[#FDFBF7]/10">
          <div className="col-span-12 lg:col-span-5">
            <div className="flex items-center gap-4">
              <img
                src={SITE.logoUrl}
                alt="The Office Meal Co."
                className="h-14 w-14 object-cover rounded-full border border-[#FDFBF7]/15"
              />
              <div>
                <div className="font-serif text-2xl">{SITE.name}</div>
                <div className="text-[10px] uppercase tracking-[0.28em] text-[#CBA365] mt-1">
                  {SITE.tagline}
                </div>
              </div>
            </div>
            <p className="mt-8 font-light text-[#FDFBF7]/70 max-w-sm leading-relaxed">
              Premium corporate catering for Bengaluru's most considered
              offices — planned, cooked and served from a single certified
              kitchen in Electronic City.
            </p>

            <div className="mt-8 flex items-center gap-3" data-testid="footer-socials">
              <a
                href={SITE.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="The Office Meal Co. on LinkedIn"
                data-testid="footer-linkedin"
                className="w-11 h-11 flex items-center justify-center border border-[#FDFBF7]/25 text-[#FDFBF7]/80 hover:bg-[#CBA365] hover:text-[#1E3A5F] hover:border-[#CBA365] transition-all duration-300"
              >
                <Linkedin size={16} strokeWidth={1.5} />
              </a>
              <a
                href={SITE.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="The Office Meal Co. on Instagram"
                data-testid="footer-instagram"
                className="w-11 h-11 flex items-center justify-center border border-[#FDFBF7]/25 text-[#FDFBF7]/80 hover:bg-[#CBA365] hover:text-[#1E3A5F] hover:border-[#CBA365] transition-all duration-300"
              >
                <Instagram size={16} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          <div className="col-span-6 lg:col-span-3">
            <div className="label-eyebrow" style={{ color: "#CBA365" }}>
              Visit
            </div>
            <p className="mt-5 font-light text-[#FDFBF7]/80 leading-relaxed text-[15px]">
              {SITE.address}
            </p>
          </div>

          <div className="col-span-6 lg:col-span-4">
            <div className="label-eyebrow" style={{ color: "#CBA365" }}>
              Reach Us
            </div>
            <ul className="mt-5 space-y-3 text-[15px]">
              <li>
                <a
                  href={`tel:+${SITE.phoneRaw}`}
                  data-testid="footer-phone"
                  className="link-underline text-[#FDFBF7]/90"
                >
                  {SITE.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  data-testid="footer-email"
                  className="link-underline text-[#FDFBF7]/90 break-all"
                >
                  {SITE.email}
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  data-testid="footer-enquire"
                  className="link-underline text-[#CBA365]"
                >
                  Request a Quote →
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[#FDFBF7]/50">
          <p>
            © {new Date().getFullYear()} {SITE.name}. All rights reserved.
          </p>
          <p className="italic font-serif text-sm text-[#FDFBF7]/60">
            Deliciously Managed · Bengaluru
          </p>
        </div>
      </div>
    </footer>
  );
}
